import Vue from 'vue'
import Vuex from 'vuex'

import article from '@/store/article.module'
import order from '@/store/order.module'
import product from '@/store/product.module'
import appointment from '@/store/appointment.module'
import common from '@/store/common.module'
import page from '@/store/page.module.js'
import auth from '@/store/auth.module.js'
import cashTransfer from '@/store/cashTransfer.module.js'
import wishlist from '@/store/wishlist.module.js'
import agent from '@/store/agent.module.js'
import review from '@/store/review.module.js'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false,
  state: {},
  modules: {
    auth,
    article,
    order,
    product,
    appointment,
    common,
    page,
    cashTransfer,
    wishlist,
    agent,
    review
  }
})
